export default "/dist/files/icon_telechargements.e0b6c5d6a37de0e0f957eeaef1bbe49a.svg";